module.exports = __webpack_public_path__ + "static/media/img_未选择分类.85acd65b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img_未选择分类.svg
// module id = 255
// module chunks = 0